import { useEffect } from 'react'

export const useClickOutside = (ref, callback, additionalCondition = true) => {
    const handleClick = e => {
        if (ref.current && !ref.current.contains(e.target)) {
            additionalCondition && callback()
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClick)

        return () => {
            document.removeEventListener('mousedown', handleClick)
        }
    })
}

export default useClickOutside